import {inject, Injectable} from '@angular/core';
import { AppConfigService } from '../app-config/app-config.service';
import { Const } from '../../../../core/helpers/Const';

@Injectable({ providedIn: 'root' })
export class SwaService {
    queue: any[] = [];
    constructor(private readonly _appConfigService: AppConfigService) {}

    init() {
        const conf = this._appConfigService.getAppConfigModel();
        if (!conf || !conf.swa_token || Const.NO_EVENT_USER_EMAILS.includes(conf.userInfo.email)) {
            return;
        }

        let swa: any = {
            pubToken: conf.swa_token,
            baseUrl: 'https://events.wa.cfapps.eu10.hana.ondemand.com/tracker/',
            owner: null,
        };
        let w: any = window;
        w.swa = swa;
        (function () {
            let d = document,
                g = d.createElement('script'),
                s = d.getElementsByTagName('script')[0];
            g.type = 'text/javascript';
            g.defer = true;
            g.async = true;
            g.src = swa.baseUrl + 'js/track.js';
            s.parentNode.insertBefore(g, s);
        })();
    }

    sendEvent(name: string) {
        this.sendCustomEvent(name, [], []);
    }

    sendCustomEvent(name: string, stringParams: string[] | undefined, numberParams: [] | undefined) {
        let w: any = window;
        let swa = w.swa;
        if (swa && swa.pubToken && typeof swa.trackCustomEvent === 'function') {
            this.doSendEvent(swa, name, stringParams, numberParams);
            while (this.getQueue().length) {
                let obj = this.queue.pop();
                this.doSendEvent(swa, obj.name, obj.stringParams, obj.numberParams);
            }
        } else {
            if (this.getQueue().length < 10) {
                this.pushQueue({ name: name, stringParams: stringParams, numberParams: numberParams });
            }
        }
    }

    doSendEvent(swa: any, name: string, stringParams: string[], numberParams: []) {
        function addDefaultsToArray(array: any, defaultValue: any) {
            if (!array || array.length === 0) {
                array = [defaultValue];
            } else if (!Array.isArray(array)) {
                array = [array];
            }
            return array;
        }
        setTimeout(function () {
            stringParams = addDefaultsToArray(stringParams, 'dummy');
            numberParams = addDefaultsToArray(numberParams, 0);
            swa.trackCustomEvent(name, stringParams, numberParams);
        }, 0);
    }

    getQueue() {
        return this.queue;
    }

    pushQueue(obj: any) {
        this.queue.push(obj);
    }

    SWA_EVENT_TYPES = {
        THEME_CHANGE: 'Theme change',
        PAGE_LOADED: 'Page loaded',
        LOGIN_PAGE_LOADED: 'Login page loaded',
        LOGIN_CLICKED: 'Login button clicked',
        RESOURCE_ACTION_CLICKED: 'Resource action clicked',
        OPEN_EDIT_RESOURCE: 'Open edit resource dialog',
        OPEN_DELETE_RESOURCE: 'Open delete resource dialog',
        OPEN_FCL_DETAILS: 'Open FCL details',
        CLOSE_FCL_DETAILS: 'Close FCL details',
        FCL_LAYOUT_SIZE_CLICKED: 'FCL layout size clicked',
        FCL_PUBLISH_CLICKED: 'FCL publish clicked',
        FCL_IMPORT_CLICKED: 'FCL import clicked',
        HEADER_HELP_CLICKED: 'Header basic help clicked',
        HEADER_WORKSPACE_HELP_CLICKED: 'Header workspace help clicked',
        OPEN_WORKSPACE_DOCS: 'Open Workspace Documentation',
        OPEN_UNIFIED_SERVICES_DOCS: 'Open Unified Services Documentation',
        OPEN_ATOMCTL_CLI_DOCS: 'Open atomctl CLI Documentation',
        HEADER_LOGOUT_CLICKED: 'Header Logout clicked',
        HEADER_SUPPORT_CLICKED: 'Header Support clicked',
        HEADER_ABOUT_CLICKED: 'Header About clicked',
        SIDE_PAGE_CLICK: 'Page clicked from side nav',
        SIDE_ORGANIZATION_CLICK: 'Organization clicked from side nav',
        SIDE_CREATE_ORGANIZATION_CLICKED: 'Create organization clicked from side nav',
        CREATE_RESOURCE_FROM_DIALOG: 'Create resource from dialog',
        CONFIRM_DELETE_RESOURCE: 'Confirm delete resource',
        CREATE_PUBLISH_CONFIGURATION: 'Create publish configuration',
        HEADER_HELP_DROPDOWN_CLICKED: 'Header help dropdown clicked',
        SUPPORT_LINK_CLICKED: 'Support link clicked',
        CLI_DOWNLOAD_CLICKED: 'CLI download link clicked',
        INFO_HELP_CLICKED: 'Info help clicked',
        OPEN_POLICIES_TAB: 'Open policies tab action clicked',
        OPEN_REFERENCES_TAB: 'Open references tab action clicked',
        OPEN_EVENTS_TAB: 'Open events tab action clicked',
        OPEN_RTD_RESOURCES_TAB: 'Open RTD resources tab action clicked',
        OPEN_DETAILS_TAB: 'Open policies tab action clicked',
        CONFIGURE_TABLE_COLUMNS: 'Configure table columns',

        OPEN_CREATE_RESOURCE_FORM: 'Open Create resource with form',
        OPEN_EDIT_RESOURCE_FORM: 'Open Edit resource with form',
        CREATE_RESOURCE_WITH_FORM: 'Create resource with form',
        EDIT_RESOURCE_WITH_FORM: 'Edit resource with form',
        CREATE_RESOURCE_WITH_FORM_SUCCESS: 'Create resource with form successfully',
        CREATE_RESOURCE_WITH_FORM_FAILED: 'Create resource with form failed',
        EDIT_RESOURCE_WITH_FORM_SUCCESS: 'Edit resource with form successfully',
        EDIT_RESOURCE_WITH_FORM_FAILED: 'Edit resource with form failed',

        OPEN_CREATE_RESOURCE_YAML: 'Open Create resource with YAML',
        OPEN_EDIT_RESOURCE_YAML: 'Open Edit resource with YAML',
        CREATE_RESOURCE_WITH_YAML: 'Create resource with YAML',
        EDIT_RESOURCE_WITH_YAML: 'Edit resource with YAML',
        CREATE_RESOURCE_WITH_YAML_SUCCESS: 'Create resource with YAML successfully',
        CREATE_RESOURCE_WITH_YAML_FAILED: 'Create resource with YAML failed',
        EDIT_RESOURCE_WITH_YAML_SUCCESS: 'Edit resource with YAML successfully',
        EDIT_RESOURCE_WITH_YAML_FAILED: 'Edit resource with YAML failed',

        COPY_YAML: 'Copy YAML',
        COPY_PATH: 'Copy Path in Create or Edit with YAML',
        SELECT_YAML_TAB: 'Select YAML tab',
        SELECT_POLICIES_TAB: 'Select Policies tab',

        RECONCILE_RESOURCE_CLICKED: 'Reconcile resource clicked',
    };
}
